import React from 'react'
import FormHOC from './FormHOC'
import InputRow from '../elements/InputRow'
import Button from '../elements/Button'

const options = {
    postUrl: '/api/postChangeLogin',
    success: 'Success! Your login details have been successfully updated.'
}
const state = {}

const ChangeLoginForm = (props) => {
    const handleInputChange = event => {
        props.handleInputChange(event)
    }

    const handleSubmit = event => {
        props.handleSubmit(event)
    }

    const handleKeyDown = event => {
        props.handleKeyDown(event)
    }

    return (
        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
            <InputRow
                label='Current Password'
                name='currentPassword'
                type='password'
                value={props.values.currentPassword}
                errors={props.errors}
                handleChange={handleInputChange}
            />
            <InputRow
                label='New Password'
                name='password'
                type='password'
                value={props.values.password}
                errors={props.errors}
                handleChange={handleInputChange}
            />
            <InputRow
                label='Confirm New Password'
                name='passwordConfirmation'
                type='password'
                value={props.values.passwordConfirmation}
                errors={props.errors}
                handleChange={handleInputChange}
            />

            {props.children}

            <div className='mt-4'>
                <Button title='Update Details' action={handleSubmit} />
            </div>
        </form>
    )
}

export default FormHOC(ChangeLoginForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/ChangeLoginForm.js